/* eslint-disable */
// src/services/counterFormulaService.js

import axios from "services/axiosConfig";

const API_URL = "/api/counter-formula";

class CounterFormulaService {
  static async getCounterFormulas() {
    try {
      const response = await axios.get(API_URL);
      return Array.isArray(response.data) ? response.data : [];
    } catch (error) {
      console.error("Error al obtener las formulas de contadores:", error);
      return [];
    }
  }

  static async getCounterFormulaById(id) {
    try {
      const response = await axios.get(`${API_URL}/${id}`);
      return response.data;
    } catch (error) {
      console.error("Error al obtener la formula de contador por ID:", error);
      return null;
    }
  }

  static async createCounterFormula(payload = {}) {
    try {
      const response = await axios.post(API_URL, {
        Type: payload.Type,
        Value: payload.Value,
      });
      return response.data;
    } catch (error) {
      console.error("Error al crear la formula de contador:", error);
      throw error;
    }
  }

}

export default CounterFormulaService;
